export default "__VITE_ASSET__5gRNqtZX__"